// Static product data for demo/fallback purposes
export interface StaticProduct {
  id: string;
  name: string;
  price: number;
  image: string;
  category: string;
  brand: string;
}

export const products: StaticProduct[] = [
  {
    id: '1',
    name: 'KOYO 6214Z Deep Groove Ball Bearing',
    price: 4400,
    image: '/placeholder.svg',
    category: 'Bearings',
    brand: 'KOYO',
  },
  {
    id: '2',
    name: 'SKF 6205-2RS1 Deep Groove Ball Bearing',
    price: 1250,
    image: '/placeholder.svg',
    category: 'Bearings',
    brand: 'SKF',
  },
  {
    id: '3',
    name: 'NTN 6303ZZ Ball Bearing',
    price: 890,
    image: '/placeholder.svg',
    category: 'Bearings',
    brand: 'NTN',
  },
  {
    id: '4',
    name: 'Timken Tapered Roller Bearing LM11949',
    price: 3200,
    image: '/placeholder.svg',
    category: 'Bearings',
    brand: 'Timken',
  },
  {
    id: '5',
    name: 'Gates A-35 Classical V-Belt',
    price: 450,
    image: '/placeholder.svg',
    category: 'Belts',
    brand: 'Gates',
  },
  {
    id: '6',
    name: 'Optibelt VB Classic V-Belt 10x6mm',
    price: 280,
    image: '/placeholder.svg',
    category: 'Belts',
    brand: 'Optibelt',
  },
  {
    id: '7',
    name: 'Bosch GLM 50 C Professional Laser Measure',
    price: 18500,
    image: '/placeholder.svg',
    category: 'Tools',
    brand: 'Bosch',
  },
  {
    id: '8',
    name: 'Makita 18V Cordless Drill Driver',
    price: 12500,
    image: '/placeholder.svg',
    category: 'Tools',
    brand: 'Makita',
  },
  {
    id: '9',
    name: 'Siemens 3RT2025-1BB40 Contactor',
    price: 2850,
    image: '/placeholder.svg',
    category: 'Electrical',
    brand: 'Siemens',
  },
  {
    id: '10',
    name: 'Schneider Electric Circuit Breaker C60N',
    price: 1650,
    image: '/placeholder.svg',
    category: 'Electrical',
    brand: 'Schneider Electric',
  },
  {
    id: '11',
    name: 'Parker Hydraulic Hose 1/2" x 50ft',
    price: 8900,
    image: '/placeholder.svg',
    category: 'Hydraulics',
    brand: 'Parker',
  },
  {
    id: '12',
    name: 'Festo Pneumatic Cylinder DSNU-25-50-P-A',
    price: 4200,
    image: '/placeholder.svg',
    category: 'Pneumatics',
    brand: 'Festo',
  },
  {
    id: '13',
    name: 'igus Energy Chain E4.28.05.032.0',
    price: 1250,
    image: '/placeholder.svg',
    category: 'Cable Management',
    brand: 'igus',
  },
  {
    id: '14',
    name: 'Rexroth Linear Guide Rail R165121420',
    price: 15600,
    image: '/placeholder.svg',
    category: 'Linear Motion',
    brand: 'Rexroth',
  },
  {
    id: '15',
    name: 'NSK Angular Contact Bearing 7210CTYNSULP4',
    price: 8750,
    image: '/placeholder.svg',
    category: 'Bearings',
    brand: 'NSK',
  },
  {
    id: '16',
    name: 'Deloitte Synthetic Oil 5W-30 5L',
    price: 1200,
    image: '/placeholder.svg',
    category: 'Lubricants',
    brand: 'Deloitte',
  },
  {
    id: '17',
    name: 'Klüber Lubrication High Temperature Grease',
    price: 3400,
    image: '/placeholder.svg',
    category: 'Lubricants',
    brand: 'Klüber',
  },
  {
    id: '18',
    name: 'Emerson Motor Starter 3 Phase 5HP',
    price: 15200,
    image: '/placeholder.svg',
    category: 'Electrical',
    brand: 'Emerson',
  },
  {
    id: '19',
    name: 'Honeywell Pressure Transmitter PX2AN1XX010BAAAX',
    price: 18900,
    image: '/placeholder.svg',
    category: 'Sensors',
    brand: 'Honeywell',
  },
  {
    id: '20',
    name: 'Rockwell Automation PLC Micro820',
    price: 28500,
    image: '/placeholder.svg',
    category: 'Automation',
    brand: 'Rockwell Automation',
  },
];
